import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/pro-duotone-svg-icons/faEdit'
import DetailContentDossier from './Detail/ContentDossier'
import AppDialog from '@/shared/ui/app-dialog/AppDialog'
import { CompactButton } from '@/shared/ui/buttons'

class DossierModalEditButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            edit: this.props.edit === true,
            size: this.props.size ? this.props.size : 'small',
            showSaveAndClose: this.props.showSaveAndClose !== false,
        }
        this.renderEdit = this.renderEdit.bind(this)
        this.renderTitle = this.renderTitle.bind(this)
        this.removeQueryTabs = this.removeQueryTabs.bind(this)
        this.handleModalClose = this.handleModalClose.bind(this)
        this.handleSuccess = this.handleSuccess.bind(this)
        //this.ref = React.createRef();
    }

    removeQueryTabs() {
        const currentUrl = window.location.href

        if (currentUrl.includes('?')) {
            const newUrl = currentUrl.split('?')[0]
            window.history.pushState({}, '', newUrl)
        }
    }

    handleModalClose() {
        this.removeQueryTabs()
        if (this.props.onClose) {
            this.props.onClose()
        }
        this.setState({ edit: false })
    }

    handleSuccess(closeIt) {
        if (this.props.onSuccess) {
            this.props.onSuccess(closeIt)
        }
        this.handleModalClose()
    }

    renderTitle() {
        if (!this.state.title) {
            return
        }

        return this.state.title()
    }

    renderEdit() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                topAlign
                title={this.renderTitle()}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        this.handleModalClose
                    }
                }}
                headerClose={this.handleModalClose}
                contentProps={{ dividers: true }}
                key={`inline-modal-${this.props.dossierId}`}
                sx={{
                    '& .MuiDialogTitle-root': {
                        pr: 7.5,
                    },
                }}
            >
                <DetailContentDossier
                    props={{
                        embeddedInlineSingle: true,
                        setTitle: (funca) => this.setState({ title: funca }),
                        modalized: true,
                        dossierId: this.props.dossierId,
                        onDeleteSuccess: this.props.onDeleteSuccess,
                        onSuccess:
                            this.state.showSaveAndClose === true
                                ? this.handleSuccess
                                : this.props.onSuccess,
                        showSaveClose: this.state.showSaveAndClose,
                        onClose: this.handleModalClose,
                        embedded: this.props.embedded,
                        disableBreadcrumb: true,
                        quickEdit: this.props.quickEdit,
                        quickShow: this.props.quickShow,
                        handlePermissions: this.props.handlePermissions,
                    }}
                    kedo={this.props.kedo}
                />
            </AppDialog>
        )
    }

    componentDidMount() {
        if (this.props.kedo.socket().getSocket()) {
            this.props.kedo.socket().getSocket().emit('dossier:exit')
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.edit !== this.state.edit) {
            return true
        }

        return false
    }

    render() {
        if (!this.props.dossierId) {
            return null
        }

        return (
            <div>
                {this.state.edit ? this.renderEdit() : null}
                <CompactButton
                    sx={{
                        display: 'inline-block',
                        float: 'right',
                    }}
                    className={'dossier-inline-edit'}
                    onClick={() => this.setState({ edit: true })}
                    size={this.state.size}
                >
                    <FontAwesomeIcon icon={faEdit} />
                </CompactButton>
            </div>
        )
    }
}

export default DossierModalEditButton
